import React, { useState, useRef, useMemo, useEffect } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useSnackbar } from "notistack";

import { Link } from "react-router-dom";
import { ModalProgressBar } from "../../../_metronic/_partials/controls";
import { useSubheader } from "../../../_metronic/layout";
import { WixPriceEditAddForm } from "./WixPriceEditAddForm";
import { createWixPricing, fetchSingleWix, updateWixPricing } from "../../../actions/wix-pricing/wix";

export function WixPriceEdit({
  history,
  match: {
    params: { id },
  },
}) {

  const { enqueueSnackbar } = useSnackbar();



  const initWixInfo = {
    plan_name: "",
    plan_type:"monthly",
    plan_desc: "",
    plan_price:"",
    inventory_type:"unlimited",
    plan_inventory:""

  };

  const { wixForEdit } = useSelector(
    (state) => ({
      wixForEdit: id ? state.wixPricing?.wixForEdit : undefined,
    }),
    shallowEqual
  );

  // Subheader
  const suhbeader = useSubheader();

  // Tabs
  const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!id) {
      suhbeader.setBreadcrumbs([{pathname:'/wix-price', title:'Wix-Price'},{pathname:'', title:'Add Wix Price'}]);
    } else {
      suhbeader.setBreadcrumbs([{pathname:'/wix-price', title:'Wix-Price'},{pathname:'', title:'Edit Wix Price'}]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useMemo(async () => {
    if (id === undefined) {
      return;
    }

    await dispatch(fetchSingleWix(id));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dispatch]);

  // set Title
  useMemo(() => {
    let _title = id ? "" : "Add Wix Price";
    suhbeader.setTitle(_title);
    setTitle(_title);

    if (id) {
      _title = "Edit Wix Price";
      setTitle(_title);
      suhbeader.setTitle(_title);
    }
    return {
      _title,
    };
  }, [id, suhbeader]);

  const saveWix = (values) => {
    setIsLoading(true);
    if (!id) {
      dispatch(createWixPricing(values)).then(async (data) => {
        if (data.payload.status) {
          if (data && data.payload) {
            await history.push(`/wix-price`);

            await enqueueSnackbar(data.payload.message, {
              variant: "success",
              autoHideDuration: 4500,
            });
            setIsLoading(false);
          }
        } else {
          await enqueueSnackbar(data.payload.message, {
            variant: "error",
            autoHideDuration: 4500,
          });
          setIsLoading(false);
        }
      });
    } else {
      dispatch(updateWixPricing(values, id)).then(async (data) => {
        if (data.payload.status) {
          if (data && data.payload) {
            await history.push(`/wix-price`);
            await enqueueSnackbar(data.payload.message, {
              variant: "success",
              autoHideDuration: 4500,
            });

            setIsLoading(false);
          }
        } else {
          await enqueueSnackbar(data.payload.message, {
            variant: "error",
            autoHideDuration: 4500,
          });

          setIsLoading(false);
        }
      });
    }
  };

  const btnRef = useRef();
  const saveWixButtonClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const backToList = () => {
    history.push(`/wix-price`);
  };

  return (
    <Card>
      {false && <ModalProgressBar />}

      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type='button'
            onClick={backToList}
            className='btn btn-light'>
            <i className='fa fa-arrow-left'></i>
            Back
          </button>
          {`  `}

          {`  `}
          <button
            type='submit'
            className='btn btn-primary ml-2'
            disabled={isLoading}
            onClick={saveWixButtonClick}>
              {isLoading ? "Saving..." : "Save"}
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <ul className='nav nav-tabs nav-tabs-line ' role='tablist'>
          <li className='nav-item' onClick={() => setTab("basic")}>
            <Link
              to={history.location.pathname}
              className={`nav-link ${tab === "basic" && "active"}`}
              data-toggle='tab'
              role='tab'
              aria-selected={(tab === "basic").toString()}>
              Basic info
            </Link>
          </li>
        </ul>
        <div className='mt-5'>
          {tab === "basic" && (
            <WixPriceEditAddForm
              wix = {wixForEdit || initWixInfo}
              id={id}
              btnRef={btnRef}
              saveWix={saveWix}
            />
          )}
          {/* If you add new tab than add more */}
        </div>
      </CardBody>
      <hr />
      <CardHeader title=''>
        <CardHeaderToolbar>
          <button
            type='button'
            onClick={backToList}
            className='btn btn-light'>
            <i className='fa fa-arrow-left'></i>
            Back
          </button>
          {`  `}

          {`  `}
          <button
            type='submit'
            className='btn btn-primary ml-2'
            disabled={isLoading}
            onClick={saveWixButtonClick}>
              {isLoading ? "Saving..." : "Save"}
          </button>
        </CardHeaderToolbar>
      </CardHeader>
    </Card>
  );
}
